
import Utils from '../components.utils.js';
export default{
   methods:{
       getProxyConvertedURL(url){
            return Utils.convertToLoginIPDomainName(url);
        },
   }
}